
import Store from './store'
import Globals from './globals'

Store.registerModule('system', Globals)
